import ListItemComponent from '../../../stories/molecules/list-items'
import {
  listItemListViewVariantOptions,
  listItemsCheckVariantOptions
} from '../../../stories/molecules/list-items/constants'
import { CopyMembersTabMembersContainer } from '../../styled-components'
import { iconSizeOptions } from '../../../stories/atoms/icons/icons-sizes'
import LoadingComponent from '../../../async-loader/loading-component'
import { isEmpty } from 'lodash'
import CopyProjectMembersEmpty from '../copy-project-members-empty'
import { copyProjectMembersTabOptions } from '../../constants'
import TeamItem from './team-item'

const checkboxCheckComponent = {
  checkInputType: listItemsCheckVariantOptions.CHECKBOX
}

const TeamsList = ({
  teams = [],
  isLoading = false,
  searchValue = '',
  selectedItemIds = [],
  onToggleSelect = () => {}
}) => {
  const selectedIdsSet = new Set(selectedItemIds)

  if (isLoading) {
    return <LoadingComponent size={iconSizeOptions['ICON-L']} />
  }

  if (isEmpty(teams)) {
    return (
      <CopyProjectMembersEmpty
        variant={copyProjectMembersTabOptions.TEAMS}
        searchValue={searchValue}
      />
    )
  }

  return (
    <ListItemComponent.Root
      listViewType={listItemListViewVariantOptions.TOGETHER}
      checkComponent={checkboxCheckComponent}
      dividerFull={false}
      hideDivider
    >
      <CopyMembersTabMembersContainer>
        {teams.map((item) => {
          return (
            <TeamItem
              key={item.id}
              item={item}
              isSelected={selectedIdsSet.has(item.id)}
              onToggleSelect={onToggleSelect}
            />
          )
        })}
      </CopyMembersTabMembersContainer>
    </ListItemComponent.Root>
  )
}

export default TeamsList
